<dx-popup
    class="popup"
    [width]="480"
    [height]="450"
    [showTitle]="true"
    title="Print Label"
    [dragEnabled]="true"
    [closeOnOutsideClick]="false"
    [showCloseButton]="true"
    (onHiding)="closing()"
    [(visible)]="popupVisible"
>
    <dxi-toolbar-item location="before">
        <dx-load-indicator
            height="20"
            width="20"
            [(visible)]="isLoading"
            style="margin-left: 8px; margin-top: 4px;"
        ></dx-load-indicator>
    </dxi-toolbar-item>
    <dxi-toolbar-item location="after">
        <dx-button text="Print" [disabled]="selectedPrinter === undefined" (click)="sendToPrinter()"></dx-button>
    </dxi-toolbar-item>

    <div *dxTemplate="let data of 'content'" style="height: 100%;">
        <div class="dx-fieldset" *ngIf="popupVisible">
            <div class="dx-fieldset-header">Printer <dx-load-indicator style="margin-right: 4px" [visible]="LoadingPrinters" [height]="16" [width]="16"> </dx-load-indicator></div>
            <div class="dx-field">
                <dx-lookup [dataSource]="printers" displayExpr="name" (onValueChanged)="printerChanged($event)">
                    <dxo-drop-down-options [showTitle]="false"></dxo-drop-down-options>
                </dx-lookup>
            </div>
        </div>

        <dx-tab-panel
            [dataSource]="requisitionLabels"
            [loop]="false"
            [animationEnabled]="true"
            [swipeEnabled]="true"
            style="min-height: 455px; padding-bottom: 16px; width: 100%;"
        >
        <div *dxTemplate="let label of 'title'">
            <span>{{label.title}}</span>
        </div>
        <div *dxTemplate="let label of 'item'">
            <img [src]='"data:image/png;base64,"+label.image'>
        </div>
        </dx-tab-panel>
    </div>
</dx-popup>
